import styled from 'styled-components';

export const SectionWrapper = styled.section`
  padding-top: 40px;
  padding-bottom: 40px;

  @media screen and (min-width: 768px) {
    padding-top: 160px;
  }
`;
